<template class="whform">
  <div class="page_chili">
    <el-row style="width:100%;padding:0" >
      <div class="block" align="right">
        <el-date-picker
          v-model="value1"
          type="datetime"
          @change="handleUserList"
          placeholder="选择日期"
        ></el-date-picker>
      </div>
    </el-row>
    <el-row style="text-align:center">
      <span>金桥变压器实时监测{{NowTime}} </span>
    </el-row>
    <el-row  class="whform" style="height:1000px">
      <el-col  class="whform">
        <div class="whform" >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="userList.length"
          ></el-pagination>
          <el-table
             class="whform"
            :data="userList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
            border
            style=" font-size: 12px;"
          >
           <el-table-column  label="序号" type="index"  width="50"   align="center">
          </el-table-column>
            <el-table-column prop="TransformerName"  width="240" label="设备名称"></el-table-column>
            <el-table-column prop="RatedU1,RatedU2" label="电压等级KV">
              <template slot-scope="scope">
                U1:{{scope.row.RatedU1}}
                <br />
                U2:{{scope.row.RatedU2}}
              </template>
            </el-table-column>
            <el-table-column prop="RatedCapacity" label="额定容量KVS"></el-table-column>
            <el-table-column prop="EpP" label="今日用电量kWh"></el-table-column>
            <el-table-column prop="P" label="有功功率kW"></el-table-column>
            <!-- <el-table-column prop="EqP" label="无功功率kVar"></el-table-column> -->
            <el-table-column prop="PowerFactorlimit" label="功率因数%"></el-table-column>
            <el-table-column prop="Ia,Ib,Ic" label="三相电流A">
              <template slot-scope="scope">
                A:{{scope.row.Ia}}
                <br />
                B:{{scope.row.Ib}}
                <br />
                C:{{scope.row.Ic}}
              </template>
            </el-table-column>
            <el-table-column prop="UA,UB,UC" label="三相电压V">
              <template slot-scope="scope">
                A:{{scope.row.UA}}
                <br />
                B:{{scope.row.UB}}
                <br />
                C:{{scope.row.UC}}
              </template>
            </el-table-column>
            <el-table-column  prop="TA,TB,TC" label="当前温度℃">
                <template slot-scope="scope">
                A:{{scope.row.TA}}
                <br />
                B:{{scope.row.TB}}
                <br />
                C:{{scope.row.TC}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
import request from "../../utils/request";
export default {
  name: "hello",
  data() {
    return {
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      userList: [],
      value1: new Date(),
      NowTime: '',
      msg: "Welcome to Your Vue.js App",
      tableData3: [],
    };
  },
  created() {
    this.handleUserList();
  },
  methods: {
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      console.log(this.pagesize); //每页下拉显示数据
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
    },
    handleUserList() {
      console.log("Page1");
      console.log(this.value1);
      var dateStr = this.value1;
      var sizeForm = {
        Page1DateTime: dateStr,
      };
      request({
        url: "MeterTrans/GetPage1Data",
        method: "post",
        data: sizeForm,
      }).then((response) => {
        var that = this;
        console.log("GetPage1Data");
        console.log("Page1Time");
        console.log(response.data.items);
        that.NowTime = response.data.items[0].SaveTime;
        that.userList = response.data.items;
      });
    },
  },
};
</script>
<style>
.whform{
  width: 100%;
  height: 100%;
}
</style>